import { createTheme, Theme } from "@mui/material/styles";
import { baseThemeParameters } from "./baseThemeParameters";

export type ThemeMode = "light" | "dark";

// Светлая схема в стиле Apple / iOS 17: чистый холодный фон с
// белоснежными карточками и мягкими hairline-разделителями.
// Слои по возрастанию яркости:
//   #F5F5F7 — общий фон (Apple grey, «дышит», не серо-грязный)
//   #FFFFFF — карточки Block / paper / secondary.main
//   #E8E8ED — вторичные плашки (кнопки-действия, чипы, hover)
// Компонент `Block` исторически ставит фон карточек из `secondary.main`,
// поэтому карточки — белые, а не paper. Плашки внутри карточек мы
// красим через `secondary.light` или явные rgba (см. HistoryRow иконки).
const lightTheme = createTheme({
  ...baseThemeParameters,
  palette: {
    mode: "light",
    primary: {
      main: "#3377FF",
    },
    secondary: {
      main: "#FFFFFF",
      light: "#E8E8ED",
    },
    background: {
      default: "#F5F5F7",
      paper: "#FFFFFF",
    },
    divider: "rgba(0, 0, 0, 0.06)",
    text: {
      primary: "#1D1D1F",
      secondary: "rgba(60, 60, 67, 0.6)",
    },
  },
});

// Тёмная схема в стиле zero-лендинга: глубокий фон с тонкой градацией
// между слоями (default → paper → surface) и hairline-разделителями.
// Не абсолютный чёрный — оставляем «дыхание» серого, чтобы карточки
// были различимы. Ориентиры (по возрастанию яркости):
//   #0F0F12 — общий фон
//   #17171A — карточки (paper)
//   #1F1F23 — вторичные плашки (кнопки-действия, чипы, инпуты)
//   #26262A — hover / выделение
const darkTheme = createTheme({
  ...baseThemeParameters,
  palette: {
    mode: "dark",
    primary: {
      main: "#3377FF",
    },
    background: {
      default: "#0F0F12",
      paper: "#17171A",
    },
    secondary: {
      main: "#1F1F23",
      light: "#26262A",
    },
    divider: "rgba(255, 255, 255, 0.07)",
    text: {
      primary: "#FFFFFF",
      secondary: "rgba(235, 235, 245, 0.55)",
    },
  },
});

export const getTheme = (mode: ThemeMode): Theme =>
  mode === "dark" ? darkTheme : lightTheme;
